export default {
  setBidCards (state, { bidCards }) {
    state.bidCards = bidCards
  },

  appendBidCard (state, { bidCard }) {
    state.bidCards = [...state.bidCards, bidCard]
  },

  updateBidCard (state, { id, bidCard }) {
    let existingBidCard = state.bidCards.find(bidCard => bidCard.id === id)
    if (existingBidCard) {
      Object.assign(existingBidCard, bidCard)
    }
  },

  resetBidCard (state, { id, bidCard }) {
    let index = state.bidCards.findIndex(bidCard => bidCard.id === id)
    if (index > -1) {
      state.bidCards.splice(index, 1, bidCard)
    }
  },

  reset (state) {
    state.bidCards = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bid-cards/mutations.js